import { alpha } from '@mui/material/styles';

import { APP_HEADER_HEIGHT } from 'constants/ui';

const getScrimColor =
  opacity =>
  ({ palette }) =>
    alpha(palette.background.paper, opacity);

export const getContainerOverlayStyles = opacity => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: getScrimColor(opacity),
  zIndex: 10,
});

export const getFullScreenOverlayStyles = opacity => ({
  position: 'fixed',
  top: `var(--app-header-height, ${APP_HEADER_HEIGHT}px)`,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: getScrimColor(opacity),
  zIndex: ({ zIndex }) => zIndex.modal,
});

export const progressStyles = {
  color: ({ palette }) => palette.primary.main,
};
